/* More Recipes rail. Scroll-snap does the layout; this only drives the arrows,
   the disabled states and the mobile progress bar. */
(function () {
  function init(root) {
    var track = root.querySelector('[data-th-more-track]');
    if (!track) return;

    var prev = root.querySelector('[data-th-more-prev]');
    var next = root.querySelector('[data-th-more-next]');
    var bar = root.querySelector('[data-th-more-bar]');

    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
      if (bar) {
        // Width is the visible fraction, offset is how far along we are, so an
        // unscrollable rail reads as full rather than empty.
        var frac = max > 0 ? track.clientWidth / track.scrollWidth : 1;
        bar.style.width = (frac * 100).toFixed(2) + '%';
        bar.style.marginInlineStart =
          (max > 0 ? (track.scrollLeft / max) * (1 - frac) * 100 : 0).toFixed(2) + '%';
      }
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function boot() {
    document.querySelectorAll('[data-th-more]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-th-more]');
    if (root) init(root);
  });
})();
